
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/zpravy-ze-sjezdovky",
      function () {
        return require("private-next-pages/[region]/[resort]/zpravy-ze-sjezdovky.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/zpravy-ze-sjezdovky"])
      });
    }
  